import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=0eb9c1db&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports